import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import themeReducer from './theme'
import userReducer from './user'
import coinsReducer from './coins'
import conversionsReducer from './conversions'
import notificationsReducer from './notifications'

const persistConfig = {
   key: 'root',
   storage,
   whitelist: ['theme', 'user', 'notifications'],
}

const rootReducer = combineReducers({
   theme: themeReducer,
   user: userReducer,
   coins: coinsReducer,
   conversions: conversionsReducer,
   notifications: notificationsReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
   reducer: persistedReducer,
})

export const persistor = persistStore(store)
